import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" To ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" From ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Subject ")
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Date ")
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Reason ")
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = { class: "small text-gray-500" }
const _hoisted_17 = { class: "col-2" }
const _hoisted_18 = { class: "col-2" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_ListView = _resolveComponent("ListView")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ListView, {
      showEdit: false,
      showTitle: false,
      name: _ctx.name,
      actions: _ctx.errorLogActions,
      resolveState: _ctx.resolveState
    }, {
      edit: _withCtx(({}) => []),
      list: _withCtx(({
        selectedItem,
        items,
        loadPage,
        setSort,
        sortBy,
        sortByDescending
      }) => [
        (items.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('To')), ["prevent"])
                  }, [
                    _hoisted_3,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "To"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_2),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('From')), ["prevent"])
                  }, [
                    _hoisted_5,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "From"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_4),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('Subject')), ["prevent"])
                  }, [
                    _hoisted_7,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "Subject"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_6),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('Date')), ["prevent"])
                  }, [
                    _hoisted_9,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "Date"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_8),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('Reason')), ["prevent"])
                  }, [
                    _hoisted_11,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "Reason"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_10)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : '')
                  }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.to), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.from), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.subject), 1),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.dateService.formatDate(item.date)), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dateService.formatTime(item.date)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.enumService.getActionReason(item.reason)), 1),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _withModifiers(($event: any) => (_ctx.retry(item, loadPage)), ["prevent"])
                      }, " Retry ", 8, _hoisted_19)
                    ])
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name", "actions", "resolveState"]),
    _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512)
  ], 64))
}